import React from "react";
import { map } from "lodash";
import { Container, TagContainer, CloseButton } from "./styled-components";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const TagsBloc = ({ options, onSelect, selectedValue }: AlertTagProps) => {
  return (
    <Container>
      {map(options, (option, index) => (
        <TagContainer
          hasOneActiveTag={selectedValue !== ""}
          isActive={option.value === selectedValue}
          key={index}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </TagContainer>
      ))}
      <CloseButton
        hasOneActiveTag={selectedValue !== ""}
        onClick={() => onSelect({ value: "", label: "" })}
      >
        <CloseIcon />
      </CloseButton>
    </Container>
  );
};

export default TagsBloc;
